import React, { useEffect, useState } from "react";
import { CircleCheck } from "lucide-react";
import { api } from "@/lib/api";
import { Stars } from "@/components/landing/CustomerReviews";

const API_BASE = process.env.REACT_APP_BACKEND_URL;

export default function BeforeAfterGallery() {
    const [items, setItems] = useState([]);
    useEffect(() => {
        api.get("/gallery").then((r) => setItems(r.data.items || [])).catch(() => {});
    }, []);
    if (!items.length) return null;

    return (
        <section data-testid="before-after-gallery" className="py-14 sm:py-20 bg-forest-900 text-cream">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                <span className="text-[11px] font-bold uppercase tracking-[0.25em] text-gold-400">Real customers · Real results</span>
                <h2 className="font-serif font-bold text-3xl sm:text-4xl mt-3">Before &amp; after from our community</h2>
                <div className="mt-10 columns-2 md:columns-3 lg:columns-4 gap-4 [&>*]:mb-4">
                    {items.flatMap((r) =>
                        r.photo_urls.map((u, i) => (
                            <figure
                                key={u}
                                data-testid={`gallery-item-${r.id}-${i}`}
                                className="break-inside-avoid bg-forest-800 rounded-2xl overflow-hidden border border-gold-500/20 group"
                            >
                                <a href={`${API_BASE}${u}`} target="_blank" rel="noreferrer" className="block overflow-hidden">
                                    <img
                                        src={`${API_BASE}${u}`}
                                        alt={`Hair result shared by ${r.name}`}
                                        loading="lazy"
                                        className="w-full h-auto transition-transform duration-500 group-hover:scale-105"
                                    />
                                </a>
                                <figcaption className="p-3 space-y-1">
                                    <Stars value={r.rating} size="w-3 h-3" />
                                    <p className="text-xs font-bold text-cream flex items-center gap-1">
                                        {r.name}
                                        {r.verified && <CircleCheck className="w-3 h-3 text-gold-400" aria-label="Verified buyer" />}
                                    </p>
                                    {r.city && <p className="text-[10px] text-cream/60">{r.city}</p>}
                                </figcaption>
                            </figure>
                        )),
                    )}
                </div>
            </div>
        </section>
    );
}
